import React from "react";
import { BarChart } from "@mui/x-charts";

const BarsChart = ({
  dataset,
  yDataKey,
  yScaleType,
  xScaleType,
  xDataKey,
  width = 250,
  height = "100%",
  layout,
  series,
}) => {
  return (
    <BarChart
      dataset={dataset}
      xAxis={[{ scaleType: xScaleType, dataKey: xDataKey }]}
      yAxis={[{ scaleType: yScaleType, dataKey: yDataKey }]}
      series={series}
      layout={layout}
      width={width}
      height={height}
    ></BarChart>
  );
};

export default BarsChart;
